module.exports = __webpack_public_path__ + "img/menu-collapsed.b7eac0dc.svg";